// import Colors from "../../../theme/colors";
const Colors = {
  white: "#FFFFFF",
  black: "#000000",
  mediumBlack: "#616161",

  // gray
  darkGray: "#8F92A1",
  mediumGray: "rgba(143, 146, 161, 0.2)",
  lightGray: "#C4C4C4",
  lightestGray: "#F2F2F2",

  // red
  mediumRed: "#FF0000",

  // blue
  darkBlue: "#171B5E",

  // green
  lightGreeen: "#0BAB5E",

  // New Blue Color
  midnightBlue: "#003E99",
  mediumBlue: "#183053",

  // Submit Button hover Color
  hoverBlue: "#0054CC",
};

const styles = {
  container: {
    fontSize: "14px",
    padding: "8px 24px 8px 24px",
    fontWeight: 500,
    width: "140px",
    height: "33px",
    borderRadius: "8px",
    textTransform: "none",
    backgroundColor: Colors.midnightBlue,
    color: Colors.white,
    "&:hover": {
      backgroundColor: Colors.hoverBlue,
      color: Colors.white,
    },
  },
  progressBar: {
    color: Colors.white,
    padding: "6px 6px 0px 6px",
    size: 25,
  },
  outLined: {
    fontSize: "14px",
    padding: "8px 24px 8px 24px",
    fontWeight: 500,
    width: "140px",
    height: "33px",
    borderRadius: "8px",
    textTransform: "none",
    backgroundColor: Colors.white,
    border: `1px solid ${Colors.midnightBlue}`,
    color: Colors.midnightBlue,
    "&:hover": {
      backgroundColor: Colors.white,
      color: Colors.hoverBlue,
      border: `1px solid ${Colors.hoverBlue}`,
    },
  },
  disabled: {
    opacity: 0.7,
  },
};

export default styles;
